import { all } from "redux-saga/effects";
import { watchAuth } from "./authSagas.js";
import { watchSystems } from "./systemsSagas.js";
import { watchHB } from "./HBSagas.js";

export default function* rootSaga() {
  yield all([
    //watchApp(),
    watchSystems(),
    watchAuth(),
    watchHB(),
  ]);
}